/* Shiok post add to cart upsell, "Nice pick! One last thing." (Boss 2026-10-07).
   Config, prices and stock come from snippets/shiok-upsell.liquid (rendered in layout/theme.liquid).
   Ported from the approved Package Finder popup; the finder now uses this module too, so there is ONE popup.

   Flow: any successful /cart/add of a product from bbq-package (DIY), live-station-bbq-assistant-package (Assist)
   or live-station-bbq-chef (Chef) -> wait until the theme's cart drawer is open -> read /cart.js -> drop what the
   cart already has (tool set, ice, and ANY drink: product type Non-Alcoholic or Alcoholic) -> open the popup on top
   of the drawer. Nothing left to offer = no popup. Live Station adds pass the booking gate first; the gate re-submits
   the theme form, so this only ever sees the add that actually reached the cart. */
(function () {
  'use strict';
  if (window.ShiokUpsell) return;
  var cfgEl = document.getElementById('shiokUpsellCfg');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (CFG.cartPage) return;   /* the cart page has its own flow; the theme redirects there instead of opening a drawer */

  var U = {
    tool: { h: 'essential-bbq-tool-set', vid: 45832123875477, per: 20, title: 'Essential BBQ Tool Set (Gas & Electric Grill)' },
    drinks: [
      { h: 'hawaiian-tropical-mocktail', title: 'Hawaiian Tropical Mocktail', v: [[45501965336725, '10 Litres (15-25pax)', 25], [45502022942869, '15 Litres (30-45pax)', 45], [45502022975637, '20 Litres (55-65pax)', 65]] },
      { h: 'rosemary-cranberry-lime-mocktail', title: 'Rosemary Cranberry Lime Mocktail', v: [[45501989617813, '10 Litres (15-25pax)', 25], [45502020845717, '15 Litres (30-45pax)', 45], [45502020878485, '20 Litres (55-65pax)', 65]] }
    ],
    ice: { h: 'ice-cube', title: 'Ice + foam box', small: [44833761427605, '4kg ice + 7-10L foam box'], big: [45297555734677, '8kg ice + 10-15L foam box'] }
  };
  var UPSUB = {
    chef: 'Your chef team brings the tools, plates and cutlery. Drinks and ice are not included, you can add them below.',
    assist: 'Your BBQ Assistant brings the grill tools, plates and cutlery. Drinks and ice are not included, you can add them below.',
    diy: 'This package is food only. Grill tools, drinks and ice are not included, you can add them below.'
  };
  var DRINK_RX = /^(non-)?alcoholic$|beverage|drink/i;

  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var money = function (c) { var n = (Math.round(c) / 100).toFixed(2).split('.'); return '$' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1]; };
  var img = function (u, w) { if (!u) return ''; return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + (w || 240); };

  /* service of a product, same rule as the finder data: a variant title naming DIY / Assistant / Chef wins, else the
     collections it sits in (both live station collections = chef) */
  function kindOf(handle, vtitle) {
    var t = String(vtitle || '').toLowerCase();
    var inD = !!CFG.h[handle], inA = !!CFG.a[handle], inC = !!CFG.c[handle];
    if (!inD && !inA && !inC) return null;
    if (/\bdiy\b/.test(t)) return 'diy';
    if (/assistant/.test(t)) return 'assist';
    if (/\bchef\b/.test(t)) return 'chef';
    if (inC) return 'chef';
    if (inA) return 'assist';
    return 'diy';
  }
  /* guests from the pax range in the variant or product title (same reading as _finder-data.py pax_range) */
  function paxOf(vtitle, ptitle) {
    var ts = [vtitle, ptitle];
    for (var i = 0; i < ts.length; i++) {
      var t = String(ts[i] || '').toLowerCase().replace(/–/g, '-');
      var m = t.match(/(\d+)\s*-\s*(\d+)\s*pax/);
      if (m) return [+m[1], +m[2]];
      m = t.match(/(\d+)\s*pax/);
      if (m) return [+m[1], +m[1]];
    }
    return null;
  }

  function items(kind, n, label) {
    var LV = CFG.up || {}, out = [];
    function live(h, vid) { var p = LV[h]; if (!p) return null; var x = p.v[vid]; return (x && x[1]) ? { price: x[0], img: p.img } : null; }
    if (kind === 'diy') {
      var t = live(U.tool.h, U.tool.vid);
      if (t) out.push({ h: U.tool.h, sec: 'To grill and serve', vid: U.tool.vid, title: U.tool.title, sub: '', price: t.price, q: Math.max(1, Math.ceil(n / U.tool.per)), img: t.img,
        why: 'Tongs, trays, plates, cutlery, cups, kitchen towel and trash bags for 20 guests. Made for gas and electric grills.' });
    }
    U.drinks.forEach(function (d, i) {
      var v = d.v.filter(function (x) { return n <= x[2]; })[0] || d.v[d.v.length - 1], q = n > 65 ? Math.ceil(n / 65) : 1, L1 = live(d.h, v[0]);
      if (L1) out.push({ h: d.h, grp: 'drinks', sec: 'Drinks (no alcohol)', vid: v[0], title: d.title, sub: v[1], price: L1.price, q: q, img: L1.img,
        why: i === 0 ? 'Our best-selling drink, sized for ' + label + '.' : 'Fresh and tangy, our second favourite.' });
    });
    var b = n > 10 ? U.ice.big : U.ice.small, I = live(U.ice.h, b[0]);   /* ice for every service, chef too */
    if (I) out.push({ h: U.ice.h, sec: 'Keep it cold', vid: b[0], title: U.ice.title, sub: b[1], price: I.price, q: n > 10 ? Math.ceil(n / 20) : 1, img: I.img,
      why: kind === 'diy' ? 'Keeps the drinks and raw food cold.' : (kind === 'assist' ? 'Ice for your drinks. The ice we deliver only keeps the food cold on the way.' : 'Keeps the drinks cold through the party.') });
    return out;
  }

  function refreshDrawer() {
    /* the theme's own drawer refresh (component-product-form.js) */
    return fetch('?section_id=helper-cart').then(function (r) { return r.text(); }).then(function (t) {
      var doc = new DOMParser().parseFromString(t, 'text/html');
      var f = doc.getElementById('AjaxCartForm'), s = doc.getElementById('AjaxCartSubtotal');
      var F = document.getElementById('AjaxCartForm'), S = document.getElementById('AjaxCartSubtotal');
      if (f && F) { F.innerHTML = f.innerHTML; if (typeof F.ajaxifyCartItems === 'function') F.ajaxifyCartItems(); }
      if (s && S) S.innerHTML = s.innerHTML;
      var cc = document.querySelector('#AjaxCartForm [data-cart-count]'), ct = document.querySelector('#AjaxCartForm [data-cart-total]');
      if (cc) document.querySelectorAll('[data-header-cart-count]').forEach(function (e) { e.textContent = cc.textContent; });
      if (ct) document.querySelectorAll('[data-header-cart-total]').forEach(function (e) { e.textContent = ct.textContent; });
    });
  }
  var origFetch = window.fetch;
  function addLines(lines) {
    return origFetch.call(window, '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-Shiok-Upsell': '1' }, body: JSON.stringify({ items: lines }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { return refreshDrawer().then(function () { return j; }, function () { return j; }); });
  }

  function close() { var u = document.getElementById('pfUp'); if (u) u.remove(); }
  function open(kind, n, label, cart) {
    close();
    var L = items(kind, n, label), last = '';
    var have = {}, drinksIn = false;
    ((cart && cart.items) || []).forEach(function (it) { have[it.handle] = true; if (DRINK_RX.test(String(it.product_type || '').trim())) drinksIn = true; });
    if (L.some(function (it) { return it.grp === 'drinks' && have[it.h]; })) drinksIn = true;
    L = L.filter(function (it) { return it.grp === 'drinks' ? !drinksIn : !have[it.h]; });
    if (!L.length) return;   /* the cart already has everything we would offer */
    var html = '<div class="pf-up shiok-up" id="pfUp" role="dialog" aria-modal="true" aria-labelledby="pfUpH"><div class="pf-up__box">' +
      '<button type="button" class="pf-up__x" data-upx aria-label="Close">&times;</button>' +
      '<h2 id="pfUpH">Nice pick! One last thing.</h2><p class="pf-up__sub">' + UPSUB[kind] + '</p>' +
      L.map(function (it, i) {
        var head = it.sec !== last ? '<p class="pf-up__sec">' + it.sec + '</p>' : ''; last = it.sec;
        return head + '<div class="pf-ui"><img src="' + esc(img(it.img, 240)) + '" alt="' + esc(it.title) + '" width="96" height="96" loading="lazy"><div>' +
          '<b>' + (it.q > 1 ? it.q + ' x ' : '') + esc(it.title) + '</b>' + (it.sub ? '<small>' + esc(it.sub) + '</small>' : '') + '<p>' + esc(it.why) + '</p>' +
          '<div class="pf-ui__f"><span>' + money(it.price * it.q) + '</span><button type="button" class="pf-ui__add" data-upadd="' + i + '">Add</button></div></div></div>';
      }).join('') +
      '<button type="button" class="pf-btn pf-up__done" data-upx>Done, view my cart</button></div></div>';
    document.body.insertAdjacentHTML('beforeend', html);
    var u = document.getElementById('pfUp');
    u.addEventListener('click', function (e) {
      if (e.target === u || e.target.closest('[data-upx]')) { close(); return; }
      var b = e.target.closest('[data-upadd]'); if (!b || b.disabled) return;
      var it = L[+b.dataset.upadd];
      b.disabled = true; b.textContent = 'Adding...';
      addLines([{ id: it.vid, quantity: it.q }]).then(function () { b.textContent = 'Added'; b.classList.add('is-done'); })
        .catch(function () { b.disabled = false; b.textContent = 'Try again'; });
    });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && document.getElementById('pfUp')) close(); });

  function drawerOpen() { var d = document.getElementById('site-cart-sidebar'); return !!(d && d.classList.contains('sidebar--opened')); }
  var pending = null;
  function trigger(item) {
    var kind = kindOf(item.handle, item.variant_title);
    if (!kind) return;
    var g = window.__shiokUpsellGuests; window.__shiokUpsellGuests = null;   /* the finder passes the guest count it was given */
    var n, label;
    if (g && g.n) { n = g.n; label = g.label || ('your ' + g.n + ' guests'); }
    else {
      var r = paxOf(item.variant_title, item.product_title), q = Math.max(1, +item.quantity || 1);
      if (r) { n = r[1] * q; label = 'your ' + (r[0] === r[1] ? r[1] * q : (r[0] * q) + '-' + (r[1] * q)) + ' guests'; }
      else { n = 20; label = 'about 20 guests'; }
    }
    if (pending) clearInterval(pending);
    var t0 = Date.now();
    /* on top of the open drawer, never instead of it: wait for the theme to open it (it does after its own refresh) */
    pending = setInterval(function () {
      if (!drawerOpen() && Date.now() - t0 < 4000) return;
      clearInterval(pending); pending = null;
      setTimeout(function () {
        origFetch.call(window, '/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
          .then(function (cart) { open(kind, n, label, cart); }).catch(function () {});
      }, 350);
    }, 100);
  }

  window.fetch = function (input, init) {
    var p = origFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var hdr = init && init.headers, self = hdr && (hdr['X-Shiok-Upsell'] || (typeof hdr.get === 'function' && hdr.get('X-Shiok-Upsell')));
      if (!self && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (res) {
          if (!res.ok) return;
          res.clone().json().then(function (j) {
            var list = j && j.items ? j.items : (j && j.handle ? [j] : []);
            for (var i = 0; i < list.length; i++) { if (kindOf(list[i].handle, list[i].variant_title)) { trigger(list[i]); break; } }
          }).catch(function () {});
        }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };

  window.ShiokUpsell = { open: open, kindOf: kindOf, paxOf: paxOf, items: items };   /* QA hook */
})();
